// « L'agent modifie l'album » + « Demandes du client » (2026-10-03) —
// components/admin/ClientRequestsCard.tsx, on the order page and beside the
// conversation. French string → English.
const m: Record<string, string> = {
  'Demandes du client': 'Client requests',
  'Chargement des demandes du client': 'Loading the client’s requests',
  'Les demandes n’ont pas pu être chargées. Réessayez dans un instant.': 'Could not load the requests. Try again in a moment.',
  '{open} à faire · {done} faites': '{open} to do · {done} done',
  'L’agent modifie l’album': 'Agent edits the album',
  'On — l’agent fait les demandes ouvertes, à partir des pages actuelles.': 'On — the agent does the open requests, from the current pages.',
  'Off — vous avez modifié à la main à {t}': 'Off — you edited by hand at {t}',
  'Off — modifié à la main par {who} à {t}': 'Off — edited by hand by {who} at {t}',
  'Off — coupé par {who} à {t}': 'Off — turned off by {who} at {t}',
  'vous': 'you',
  'Activé': 'On',
  'Désactivé': 'Off',
  'Rallumez-le : l’agent reprend les {n} demandes ouvertes, en gardant vos modifications.':
    'Turn it on: the agent picks up the {n} open requests and keeps your changes.',
  'Pages de l’album seulement — l’assistant continue de répondre au client dans tous les cas.':
    'Album pages only — the assistant keeps answering the client either way.',
  'L’agent album WhatsApp est sur « {mode} » dans les réglages : les demandes WhatsApp attendent.':
    'The WhatsApp album agent is set to « {mode} » in settings: WhatsApp requests wait.',
  'Non enregistré : {why}': 'Not saved: {why}',
  'Aucune demande du client pour l’instant.': 'No client requests yet.',
  'Faites ({n})': 'Done ({n})',
  'À faire': 'To do',
  'Fait par vous · {t}': 'Done by you · {t}',
  'Fait par {who} · {t}': 'Done by {who} · {t}',
  'Fait par l’agent · {t}': 'Done by the agent · {t}',
  'Fait par l’agent': 'Done by the agent',
  'Fait': 'Done',
  'L’agent n’a pas pu : {why}': 'The agent couldn’t: {why}',
  'À vous : {why}': 'Needs you: {why}',
  '{n} photo(s) envoyée(s)': '{n} photo(s) sent',
  'Rouvrir pour l’agent : {text}': 'Reopen for the agent: {text}',
  'Marquer comme fait : {text}': 'Mark as done: {text}',
  'Album {a} · p. {p}': 'Album {a} · p. {p}',
  'Aperçu · p. {p}': 'Preview · p. {p}',
  'Aperçu · couverture': 'Preview · cover',
  'Aperçu · dos de l’album': 'Preview · back cover',
  'Album {a} · couverture': 'Album {a} · cover',
  'Album {a} · dos de l’album': 'Album {a} · back cover',
  '+{n} photo(s)': '+{n} photo(s)',
  '{n} jamais reçue(s) — à renvoyer en Document': '{n} never reached us — ask her to resend as a Document',
  'dit {n} fois': 'said {n} times',
  'L’agent réessaie cette demande à partir des pages actuelles.': 'The agent tries this request again, from the current pages.',
  'Rendre à l’agent': 'Give back to the agent',
  'Demandes': 'Requests',
  'Demandes du client — {n} à faire': 'Client requests — {n} to do',
  'Une par une, avec qui a fait quoi : « Demandes du client » ci-dessus.': 'One by one, with who did what: « Client requests » above.',
  // ── Filter + sort (2026-10-07) ──
  'Afficher': 'Show',
  'Faites': 'Done',
  'Toutes': 'All',
  'Tri : page ↑': 'Sort: page ↑',
  'Tri : ordre demandé': 'Sort: order asked',
  'Tout est fait.': 'Everything is done.',
  'Rien de fait pour l’instant.': 'Nothing done yet.',
};
export default m;
